import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { CanalMidiaSocial, canaisMidiasSociais as canaisDefault, isCanalMidiaSocialFacebook, isCanalMidiaSocialInstagram, isCanalMidiaSocialLinkedin, isCanalMidiaSocialWhatsApp, isCanalMidiaSocialOutro } from '../../canal-midia-social';

interface Config {
    isFacebook: boolean;
    isInstagram: boolean;
    isLinkedin: boolean;
    isWhatsApp: boolean;
    isOutro: boolean;
    isValid?: boolean;
}

@Component({
    selector: 'sgt-canal-midia-social-select',
    templateUrl: './canal-midia-social-select.component.html',
    styleUrls: ['./canal-midia-social-select.component.less']
})
export class CanalMidiaSocialSelectComponent implements OnInit, OnChanges {
    config: Config;

    /** Canais de mídias sociais disponíveis para seleção */
    @Input() canaisOptions: CanalMidiaSocial[] = canaisDefault;

    /** Canal */
    @Input() idCanalMidiaSocial: number;
    /** Ao alterar o canal */
    @Output() idCanalMidiaSocialChange = new EventEmitter<number>();
    /** Canal de mídia social selecionado */
    canalMidiaSocial: CanalMidiaSocial;
    /** Canal de mídia social alterado */
    @Output() canalMidiaSocialChange = new EventEmitter<CanalMidiaSocial>();

    /** Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se se o canal é obrigatório */
    @Input() required = false;

    @ViewChild('dropdownToggle') dropdownToggle: ElementRef;

    ngOnInit(): void {
        this.canalMidiaSocial = this.canaisOptions.find(canalFilter => canalFilter.id == this.idCanalMidiaSocial);
        this.setConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'required' && !changes[propName].isFirstChange()) {
                this.setIsValid();
            }
        }
    }

    /** Ao selecionar o canal */
    select(canal: CanalMidiaSocial) {
        this.idCanalMidiaSocial = canal ? canal.id : null;
        this.idCanalMidiaSocialChange.emit(this.idCanalMidiaSocial);
        this.canalMidiaSocial = canal;
        this.canalMidiaSocialChange.emit(this.canalMidiaSocial)

        this.setConfig();
    }

    /** Seta as configs. do select */
    private setConfig() {
        this.config = {
            isFacebook: isCanalMidiaSocialFacebook(this.idCanalMidiaSocial),
            isInstagram: isCanalMidiaSocialInstagram(this.idCanalMidiaSocial),
            isLinkedin: isCanalMidiaSocialLinkedin(this.idCanalMidiaSocial),
            isWhatsApp: isCanalMidiaSocialWhatsApp(this.idCanalMidiaSocial),
            isOutro: isCanalMidiaSocialOutro(this.idCanalMidiaSocial)
        }
        this.setIsValid();
    }

    private setIsValid() {
        // Obrigatório e não selecionada o canal
        if (this.required && !this.idCanalMidiaSocial) {
            this.config.isValid = false;
            return;
        }

        this.config.isValid = true;
    }

    get isValid(): boolean {
        return this.config.isValid;
    }

    /** Seta foco no select */
    setFocus() {
        jQuery(this.dropdownToggle?.nativeElement).trigger('focus');
    }
}
